import React from "react";
import Modal from "react-modal";
import JobDescriptionTable from "./JobDescriptionTable";
Modal.setAppElement("#root");

const customStyles = {
	overlay: {
		backgroundColor: "rgba(0, 0, 0, 0)", // fully transparent; change to rgba(0,0,0,0.5) for dim without blur
	},
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		padding: "2rem",
		borderRadius: "10px",
		// border: "10px",

		maxHeight: "90vh", // Limit height for smaller screens
	},
};

const PreLoadedJobExamplesModal = () => {
	const [modalIsOpen, setIsOpen] = React.useState(false);


	function openModal() {
		setIsOpen(true);
	}

	function closeModal() {
		setIsOpen(false);
	}

	return (
		<div className="font-body">
			<button
				onClick={openModal}
				className="w-36 py-2 bg-[#BDE4C3] text-[#438437] rounded-md  hover:scale-110 transition"
			>
				Load Examples
			</button>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div className="py-2 md:w-[60vw] ">
					{/* <button
						onClick={closeModal}
						className="absolute top-2 md:right-3 right-8 p-2 rounded-full bg-red-500 text-white font-medium  shadow-md hover:bg-red-400 focus:outline-none focus:ring-2 focus:ring-red-300 transition-transform transform hover:scale-105"
						aria-label="Close Modal"
					>
						<IoClose size={20} />
					</button> */}

					<h2 className="text-2xl text-center  font-semibold text-gray-800 mb-4 ">
						Job Examples
					</h2>
					<JobDescriptionTable

						setIsOpen={setIsOpen}
					/>
				</div>
			</Modal>
		</div>
	);
};

export default PreLoadedJobExamplesModal;
